/**
 * Error reporting leggero — scrive errori su Firestore collection `error_logs`.
 * Visibili dalla Firebase Console (Firestore > error_logs).
 *
 * Cattura:
 * - Errori React (via ErrorBoundary)
 * - Promise non gestite (unhandledrejection)
 * - Errori globali (window.onerror)
 */

import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db, firebaseConfigValid } from '@/lib/firebase';

const MAX_REPORTS_PER_SESSION = 20;
let reportCount = 0;

/**
 * Scrive un errore su Firestore. Limita a 20 errori per sessione
 * per evitare loop infiniti che riempiono il DB.
 */
export async function reportError({ error, context = '', componentStack = '', userId = null, userEmail = null }) {
  if (!firebaseConfigValid || !db) return;
  if (reportCount >= MAX_REPORTS_PER_SESSION) return;
  reportCount++;

  try {
    await addDoc(collection(db, 'error_logs'), {
      message: error?.message || String(error),
      stack: (error?.stack || '').slice(0, 2000),
      componentStack: (componentStack || '').slice(0, 1000),
      context,
      userId: userId || null,
      userEmail: userEmail || null,
      url: window.location.href,
      userAgent: navigator.userAgent,
      timestamp: serverTimestamp(),
    });
  } catch (e) {
    // Non propagare errori di reporting
  }
}

/**
 * Installa listener globali per catturare errori non gestiti.
 * Chiamare una volta al mount dell'app.
 */
export function installGlobalErrorHandlers(getUser) {
  window.addEventListener('unhandledrejection', (event) => {
    const error = event.reason;
    const user = getUser?.() || {};
    reportError({
      error: error instanceof Error ? error : new Error(String(error)),
      context: 'unhandledrejection',
      userId: user.uid,
      userEmail: user.email,
    });
  });

  window.addEventListener('error', (event) => {
    const user = getUser?.() || {};
    reportError({
      error: event.error || new Error(event.message),
      context: 'window.onerror',
      userId: user.uid,
      userEmail: user.email,
    });
  });
}
